export const consultCategory = {
  know: [
    // {
    //   id: 'a2e1dcba56044263a552baf9ce62cab4',
    //   name: '办公室',
    //   showUIViewType: true,
    // },
    {
      id: 'da6bb57ac2924e9a979aab9c7cfdd031',
      name: '组织和宣传教育部',
      showUIViewType: true,
    },
    {
      id: 'cbb20795b5b9420a96fbebb85369edce',
      name: '劳动和经济工作部',
      showUIViewType: true,
    },
    {
      id: 'ef49c24f2a2f4a2b8bfedfc8ddf57215',
      name: '权益保障部',
      showUIViewType: true,
    },
    {
      id: '938f2e1e4b9744d184dba51dea908747',
      name: '财务资产管理部',
      showUIViewType: true,
    },
    {
      id: '3cf992be23014707a9e9da426020feef',
      name: '女职工部',
      showUIViewType: true,
    },
    {
      id: '903137bb42014cd8a498c92aa2978cbf',
      name: '经审办',
      showUIViewType: true,
    },
    {
      id: '8ea5e89d0ddb42839788d091be3ebbbb',
      name: '教科文卫体',
      showUIViewType: true,
    },
    {
      id: 'f78fef0fb07e48d1a8883c6b946cba62',
      name: '工人文化宫',
      showUIViewType: true,
    },
    {
      id: '3f9b00696eab42cc8b2039deda57b49a',
      name: '职工学校',
      showUIViewType: true,
    },
  ],
  unit: [
    {
      id: '923ae04d2c344354bf872cb35962ef49',
      name: '权益保障',
      showUIViewType: true,
      label: 'rights'
    },
    {
      id: 'a0359fc468a741a0b8647adc17eb3d3d',
      name: '法律资讯',
      showUIViewType: true,
      label: 'law'
    },
    {
      id: '5626173047534bf89f2c8bf672d7067f',
      name: '民主管理',
      showUIViewType: true,
      label: 'democracy'
    },
    {
      id: '8ef5aacdce9f4bc095012f0b3488e274',
      name: '婚恋交友',
      showUIViewType: true,
      label: 'marriage'
    },
    {
      id: 'ba216b597f2e4732b62d6ac57f4e69db',
      name: '基层动态',
      showUIViewType: true,
      label: 'bases'
    },
    {
      id: '38bf6905d8e54e2ea3ea77067fc20086',
      name: '普惠资讯',
      showUIViewType: true,
      label: 'inclusive'
    },
    {
      id: '1ca06650527946da809dff5eb2a3aa29',
      name: '有问有答',
      showUIViewType: true,
      label: 'dialog'
    }
  ]
}

export const workerCategroy = {
  model: '31c5ce193e1d488faf2e60a9cc2fa0c1',
  heroine: 'bda1c5d3532d47ea984732e0708a0f43'
}

export const menuCategory = {
    news: {
      name: '时政要闻',
      id: '950c8411772a4896a90c42980a91644a'
    },
    consult: {
      name: '综合资讯',
      id: 'cc5767961b1c44bebebfa81be4194468'
    },
    data: {
      name: '文件资料',
      id: '43cf3dc0564d47e792cde92f95b7c245'
    },
    history: {
      name: '走红色百年路 学建党百年史',
      id: 'e7796cb83b644e0290f2de85d73ebc88'
    },
    event: {
      name: '“五大行动”、“十件实事” 及特色工作',
      id: 'b40f53040a214e3b9285a3327e431046'
    },
    worker: {
      name: '劳动模范',
      id: '31c5ce193e1d488faf2e60a9cc2fa0c1'
    },
    heroine: {
      name: '巾帼风采',
      id: 'bda1c5d3532d47ea984732e0708a0f43'
    }
}

export const provinceLinks = [{"linkUrl":"http://www.bjzgh.org/","name":"北京"},{"linkUrl":"http://www.ftutj.cn/","name":"天津"},{"linkUrl":"http://www.hebgh.org/","name":"河北"},{"linkUrl":"http://www.sxgh.org.cn/","name":"山西"},{"linkUrl":"http://www.nmgzgh.org.cn/","name":"内蒙古"},{"linkUrl":"http://www.lnszgh.org/","name":"辽宁"},{"linkUrl":"http://www.jlzgh.cn/","name":"吉林"},{"linkUrl":"http://www.hljgh.org.cn/","name":"黑龙江"},{"linkUrl":"https://www.shzgh.org/","name":"上海"},{"linkUrl":"http://www.jsgh.org/","name":"江苏"},{"linkUrl":"https://www.zjftu.org/","name":"浙江"},{"linkUrl":"https://www.ahghw.org/","name":"安徽"},{"linkUrl":"http://www.fj12351.cn/","name":"福建"},{"linkUrl":"http://www.jxgh.org.cn/","name":"江西"},{"linkUrl":"http://www.sdgh.org.cn/","name":"山东"},{"linkUrl":"http://www.hngh.org/","name":"河南"},{"linkUrl":"http://www.hbzgh.org.cn/","name":"湖北"},{"linkUrl":"https://www.hnghw.com/#/home","name":"湖南"},{"linkUrl":"http://www.gdftu.org.cn/","name":"广东"},{"linkUrl":"http://www.gxftu.org/","name":"广西"},{"linkUrl":"http://www.hnszgh.org/web/default/index.jsp","name":"海南"},{"linkUrl":"http://www.cqgh.org/","name":"重庆"},{"linkUrl":"http://www.scgh.org/","name":"四川"},{"linkUrl":"http://www.guizgh.org.cn/f","name":"贵州"},{"linkUrl":"https://ynzgh.org.cn/portal/#/home","name":"云南"},{"linkUrl":"http://xz.workercn.cn/","name":"西藏"},{"linkUrl":"http://www.shxgh.org/","name":"陕西"},{"linkUrl":"http://www.gsgh.org/","name":"甘肃"},{"linkUrl":"http://www.qhszgh.org/","name":"青海"},{"linkUrl":"http://www.nxzgh.org.cn/","name":"宁夏"},{"linkUrl":"http://www.xjzgh.org.cn/","name":"新疆"},{"linkUrl":"http://btftu.xjbt.gov.cn/","name":"新疆兵团"}]
